import React from "react";
import Modal from "../Modal/modal";
import "./talkToUsModal.scss";

const TalkToUsModal = ({ isOpen, onClose, data }) => {
  const {
    expectedWaitTime,
    businessStartTime,
    businessEndTime,
    phoneNumber,
    isAvailable,
  } = data;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="talk-to-us-modal">
        <p className="heading">Talk To Us</p>

        <div className="tele-number-wrapper">
          <p className="tele-number">{phoneNumber}</p>
          <p
            className={`wait-time-wrapper ${
              isAvailable ? "" : "disabled"
            }`}
          >
            {isAvailable
              ? `Wait time: ${expectedWaitTime}min`
              : "Not Available"}
          </p>
        </div>
        <p className="desc">
          {`${businessStartTime} to ${businessEndTime} on Market Trading days`}
        </p>
        <p className="desc">
          Standard calling rates apply.
        </p>
      </div>
    </Modal>
  );
};

export default TalkToUsModal;
